/**
 * Get value of a query string from the URL
*/

import EventBus from './../event-bus.js'

const ReadUrlParameter = {

    /**
     * Read url parameter
     * @param params
    */
    readUrlParam(params) {
    
        let
            name = params.name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'),
            regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
            results = regex.exec(location.search)
        
        params.callback(results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' ')))
    
    },
    
    /**
     * Bind events
    */
    bindEvents() {
        EventBus.subscribe('read-url-parameter', this.readUrlParam.bind(this))
    }

}

ReadUrlParameter.bindEvents()

export default ReadUrlParameter